import React, { useEffect, useState } from "react";
import Provider from "./Provider";
function BatimentGame(props) {
    return <Provider />
}

export default BatimentGame;